// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ReactDOMStyle from "../../../../node_modules/@rescript/react/lib/es6_global/src/ReactDOMStyle.bs.js";
function addMaybe(style, maybe) {
  return Belt_Option.mapWithDefault(maybe, style, function (param) {
    return ReactDOMStyle.unsafeAddProp(style, param[0], param[1]);
  });
}
function combineMaybe(style, maybe) {
  return Belt_Option.mapWithDefault(maybe, style, function (toCombine) {
    return Object.assign({}, style, toCombine);
  });
}
function sanitizeFontFamily(fontFamily) {
  var fallback = "sans-serif";
  return Belt_Option.getWithDefault(Belt_Option.map(Belt_Array.get(fontFamily.split(";"), 0), function (fontFamily) {
    return Belt_Array.concat(Belt_Array.keep(Belt_Array.keepMap(fontFamily.split(/\,[\s]/), function (s) {
      return s;
    }), function (s) {
      return s !== fallback;
    }), [fallback]).join(",");
  }), fontFamily);
}
function weightToString(fontWeight) {
  switch (fontWeight) {
    case /* WeightAuto */0:
      return;
    case /* WeightThin */1:
      return "100";
    case /* WeightLight */2:
      return "300";
    case /* WeightNormal */3:
      return "400";
    case /* WeightMedium */4:
      return "500";
    case /* WeightSemiBold */5:
      return "600";
    case /* WeightBold */6:
      return "700";
  }
}
function artToString(fixedOpt, art, color) {
  var fixed = fixedOpt !== undefined ? fixedOpt : false;
  if (typeof art === "number") {
    return color;
  }
  if (art.TAG !== /* GradientArt */0) {
    return art._0;
  }
  var gradient = art._0.trim();
  if (gradient.endsWith(")") && fixed) {
    return gradient + " no-repeat 0 0 / 100vw 100vh";
  } else {
    return gradient;
  }
}
function makeStyle(theme) {
  var match = theme.backgroundArt;
  var tmp;
  tmp = typeof match === "number" || match.TAG !== /* GradientArt */0 ? undefined : ["--smartnav-background-attachment", "fixed"];
  return ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(addMaybe(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(ReactDOMStyle.unsafeAddProp(addMaybe(addMaybe(ReactDOMStyle.unsafeAddProp(addMaybe(addMaybe(addMaybe(ReactDOMStyle.unsafeAddProp(addMaybe({}, Belt_Option.map(Belt_Option.map(theme.bodyFont.fontFamily, sanitizeFontFamily), function (fontFamily) {
    return ["--smartnav-font-family", fontFamily];
  })), "--smartnav-font-scale", String(theme.bodyFont.fontSizeScale)), Belt_Option.map(Belt_Option.flatMap(theme.bodyFont.fontWeight, weightToString), function (weight) {
    return ["--smartnav-font-weight", weight];
  })), Belt_Option.map(Belt_Option.map(theme.headingFont.fontFamily, sanitizeFontFamily), function (fontFamily) {
    return ["--smartnav-heading-font-family", fontFamily];
  })), Belt_Option.map(Belt_Option.flatMap(theme.headingFont.fontWeight, weightToString), function (weight) {
    return ["--smartnav-heading-font-weight", weight];
  })), "--smartnav-heading-font-scale", String(theme.headingFont.fontSizeScale)), Belt_Option.map(Belt_Option.map(theme.buttonFont.fontFamily, sanitizeFontFamily), function (fontFamily) {
    return ["--smartnav-button-font-family", fontFamily];
  })), Belt_Option.map(Belt_Option.flatMap(theme.buttonFont.fontWeight, weightToString), function (weight) {
    return ["--smartnav-button-font-weight", weight];
  })), "--smartnav-button-font-scale", String(theme.buttonFont.fontSizeScale)), "--smartnav-color-primary", theme.primaryColor), "--smartnav-color-secondary", theme.secondaryColor), "--smartnav-color-tertiary", theme.tertiaryColor), "--smartnav-color-accent", theme.accentColor), "--smartnav-color-drawer-main", theme.drawerBackgroundColor), "--smartnav-color-drawer-label", theme.drawerLabelColor), "--smartnav-background-color", theme.backgroundColor), "--smartnav-background-art", artToString(true, theme.backgroundArt, theme.backgroundColor)), tmp), "--smartnav-border-radius", theme.roundedEdges), "--smartnav-col-gutter", theme.columnGutter), "--smartnav-row-gutter", theme.rowGutter), "--smartnav-section-vertical-padding", theme.sectionVerticalPadding), "--smartnav-section-padding-top", Belt_Option.getWithDefault(theme.sectionPaddingTop, theme.sectionVerticalPadding)), "--smartnav-section-padding-bottom", Belt_Option.getWithDefault(theme.sectionPaddingBottom, theme.sectionVerticalPadding)), "--smartnav-color-placeholder", theme.placeholderColor), "--smartnav-color-product-discount-main", theme.productPriceDiscountBackgroundColor), "--smartnav-color-product-discount-label", theme.productPriceDiscountLabelColor), "--smartnav-color-product-promo-main", theme.productPromoBackgroundColor), "--smartnav-color-product-promo-label", theme.productPromoLabelColor);
}
var Font;
var Color;
var Px;
export { Font, Color, Px, addMaybe, combineMaybe, sanitizeFontFamily, weightToString, artToString, makeStyle };
/* No side effect */